import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { ImpostosTable } from './ImpostosTable';
import type { Iis, Iic } from '@/services/SimplesNacional/Segregacao/api/types';

interface ImpostoInternoTabsProps {
  iis: Iis[];
  iic: Iic[];
  onClickLinha?: (linha: string) => void;
}

export function ImpostoInternoTabs({ iis, iic, onClickLinha }: ImpostoInternoTabsProps) {
  return (
    <Tabs defaultValue="sem-st">
      <TabsList>
        <TabsTrigger value="sem-st">Sem Substituição Tributária</TabsTrigger>
        <TabsTrigger value="com-st">Com Substituição Tributária</TabsTrigger>
      </TabsList>
      <TabsContent value="sem-st">
        <ImpostosTable data={iis} onClickLinha={onClickLinha} />
      </TabsContent>
      <TabsContent value="com-st">
        <ImpostosTable data={iic} onClickLinha={onClickLinha} />
      </TabsContent>
    </Tabs>
  );
}
